function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#D80027"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.82597 6.05208C8.64416 6.8083 8.32113 6.66408 8.1626 7.32358C7.22876 7.09905 6.65364 6.15999 6.87817 5.22608C7.10261 4.29224 8.04176 3.71712 8.97562 3.94165C8.65853 5.26062 8.98862 5.37574 8.82597 6.05208Z",
  fill: "#F0F0F0"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.4028 6.61255C7.06583 7.01912 6.82883 7.28183 7.40702 7.63643C6.90489 8.45521 5.83411 8.71193 5.0153 8.20983C4.19652 7.70774 3.93974 6.6369 4.44186 5.81812C5.5983 6.52724 5.8097 6.2489 6.4028 6.61255Z",
  fill: "#F0F0F0"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.18712 9.09035C6.77871 8.58541 6.95525 8.89197 7.47115 8.45166C8.09475 9.1822 8.008 10.28 7.2775 10.9035C6.54693 11.5271 5.44918 11.4403 4.82568 10.7098C5.85737 9.8291 5.65796 9.54195 6.18712 9.09035Z",
  fill: "#F0F0F0"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.21072 10.5512C7.91322 9.83253 8.25934 9.75929 8 9.13263C8.88747 8.76535 9.90471 9.18704 10.272 10.0745C10.6393 10.962 10.2176 11.9792 9.33009 12.3465C8.81144 11.0931 8.47678 11.194 8.21072 10.5512Z",
  fill: "#F0F0F0"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.1077 8.18364C9.33227 8.24448 9.36949 7.89261 8.6934 7.94567C8.6183 6.9882 9.33374 6.15098 10.2913 6.07583C11.2488 6.00086 12.086 6.71623 12.161 7.6738C10.8086 7.77983 10.8011 8.1293 10.1077 8.18364Z",
  fill: "#F0F0F0"
});
const SvgHongKong = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHongKong, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hong-kong.61ffb3ec.svg";
export { ForwardRef as ReactComponent };